import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import WeekDay from 'dayjs/plugin/weekday';
import LocaleData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

import { i18nInitPromise } from './providers/i18nProvider';
import { initSentry } from '@/utils/sentry';
import App from './App';

initSentry();

dayjs.extend(WeekDay);
dayjs.extend(LocaleData);
dayjs.extend(LocalizedFormat);

void i18nInitPromise.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
});
